export const FullscreenExitIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true" fill="#fff" role="img">
    <path d="M9 9h5v2h-3v3H9V9zM0 9h5v5H3v-3H0V9zm3-9h2v5H0V3h3V0zm11 3v2H9V0h2v3h3z" />
  </svg>
);
